export default __webpack_public_path__ + "static/media/pin.5494dc7a.png";